import Cookies from 'js-cookie';

export const addCookie = (name: string, value: string) => {
  Cookies.set(name, value, { domain: '.cian.ru' });
};

export const removeCookie = (name: string) => {
  Cookies.remove(name, { domain: '.cian.ru' });
};
